import React from "react";
import { AiOutlineReload } from "react-icons/ai";

export const RefreshButton = ({ onClick, buttonName }) => {
  return (
    <button
      className="flex items-center p-1 md:p-2 border border-primary text-primary rounded-2xl hover:bg-primary hover:text-white focus:outline-none"
      onClick={onClick}
    >
      <AiOutlineReload className="hidden md:flex text-xs md:text-sm" />
      <span className="md:ml-2">{buttonName}</span>
    </button>
  );
};
